/* eslint-disable */
import React from 'react'
import { Layout, Row, Col, Divider } from 'antd'
import { useTranslation } from 'react-i18next'

const { Header, Footer, Sider, Content } = Layout;
const footStyle= {
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '22px',
    alignItems: 'center',
    letterSpacing: '0.1em'
  }
  const footTextStyle= {
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '18px',
    lineHeight: '22px',
    alignItems: 'center',
    letterSpacing: '0.1em',
    textAlign:'center',
    color:'white'
  }

export default function MyFooter() {
  // i18n language switch
  const { t } = useTranslation()
  return (
    <div className="footer" style={{backgroundColor:'#7DB926'}}>
    <Footer style={{height:'260px', background: '#7DB926', padding:'30px 7vw 70px', maxWidth: '1920px', margin:'0 auto' }}>
    <Row style={{padding:'30px 0px', color:'white', maxWidth: '1280px', margin:'0 auto'}} justify='space-between'>
      
      <Col>
        <img src={'/footer/Wi_logo-bggreen.svg'} width={'201px'} height={'56.99px'} style={{marginRight:'20px'}} alt="logo" />
      </Col>

      <Col style={footStyle}>
        {/* <img src={'/footer/iconLight.svg'} width={'23px'} height={'23px'} style={{marginRight:'20px'}} alt="logo" />
        <a style={{ color:'white'}} href='/FAQ'>{t('Footer.FAQ')}</a> */}
      </Col>
      <Col style={footStyle}>
        {/* <img src={'/footer/iconDocument.svg'} width={'21px'} height={'21px'} style={{marginRight:'20px'}} alt="logo" />
        <a style={{ color:'white'}} href='/Term'>{t('Footer.Terms')}</a> │ <a style={{ color:'white'}} href='/Privacy'>{t('Footer.Policy')}</a> */}
      </Col>
      <Col style={footStyle}>
        {/* <a style={{ color:'white'}} onClick={()=>window.open(`${process.env.REACT_APP_PARTNER}`)}>
          <img src={'/footer/iconPartner.svg'} width={'21px'} height={'21px'} style={{marginRight:'20px'}} alt="logo" />
          {t('Footer.Partners')}
        </a> */}
      </Col>
      <Col style={footStyle}>
        <a style={{ color:'white'}} onClick={()=>window.open(`mailto:appservice@wiadvance.com`)}>
        <img src={'/footer/iconMail.svg'} width={'21px'} height={'21px'} style={{marginRight:'20px'}} alt="logo" />
        {t('Footer.Email')}
        <br/>
        {t('Global.appservice')} 
        </a>
      </Col>   
      <div className="copyrightcol" style={footTextStyle}>{t('Global.CompanyName')}</div>
      <div className="copyrightcol" style={footTextStyle}>{t('Global.Copyright')}</div>
      <Divider style={{borderTop: '1px solid white', marginTop:'50px'}}/>
      
    </Row>
    <div className="copyrightmid" style={footTextStyle}>{t('Global.CompanyName')}</div>
    <div className="copyrightmid" style={footTextStyle}>{t('Global.Copyright')}</div>
  
  </Footer>
  </div>
  )
}
